<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar class="block w-full" name="Dictee | Fysiek" [steps]="words().length" [progress]="index()" />

  <rid-mechanic-content>
    <!-- title -->
    @if (state() === 'WRITING') {
      <rid-mechanic-title [title]="'Schrijf het woord in je schrift'" />
    }

    <div class="grid grid-rows-2 justify-items-center gap-8">
      <!-- audio -->
      <div class="relative">
        <rid-audio-button src="FOR SIZING" size="SMALL" class="pointer-events-none invisible" />

        @for (input of [word().audio]; track input) {
          <rid-audio-button
            #audioButton
            class="absolute inset-0"
            [src]="word().audio"
            size="SMALL"
            animate.enter="wait-500 anim-pop-in"
            animate.leave="anim-fade-out"
            (animationend)="$event.animationName === 'pop-in' ? start() : undefined"
          />
        }
      </div>

      @if (state() === 'FEEDBACK') {
        <rid-segmented-word-card
          #segmentedWordCard
          [segments]="segmentsMap().get(index())!"
          animate.enter="anim-pop-in"
          animate.leave="anim-pop-out"
          (mouseenter)="segmentedWordCard.decompress()"
          (mouseleave)="segmentedWordCard.compress()"
        />
      }
    </div>

    @if (state() === 'WRITING') {
      <rid-bottom-button content="Klaar!" (clicked)="state.set('FEEDBACK')" />
    }

    @if (state() === 'FEEDBACK') {
      <rid-assessment-toast (assessed)="$event === 'CORRECT' ? markCorrect() : markIncorrect()" />
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
